exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-dropzone[data-v-ffe8a04a]{min-height:126px}.dz-add-files[data-v-ffe8a04a]{padding-top:45px}.dz-uploaded-file[data-v-ffe8a04a]{cursor:default}", ""]);

// exports
